import { Component, OnInit, Input } from '@angular/core';

export interface ImagemTituloDescricaoData {
  image: string;
  title: string;
  description: string;
}

@Component({
  selector: 'fcp-imagem-titulo-descricao',
  templateUrl: './imagem-titulo-descricao.component.html',
  styleUrls: ['./imagem-titulo-descricao.component.scss']
})
export class ImagemTituloDescricaoComponent implements OnInit {
  @Input() public imagemTituloDescricao: ImagemTituloDescricaoData;

  constructor() { }

  ngOnInit(): void {
  }

}
